import React from 'react';
import { SEAT_LABELS } from '../utils/tableSeats';

function SpadesBidPanel({
  phase,
  turnSeat,
  viewerSeat,
  doubleNilEnabled,
  viewerBid,
  viewerBiddingChoice,
  onBiddingChoice,
  onBid,
  floating = false,
}) {
  if (!viewerSeat || turnSeat !== viewerSeat) return null;

  const panelClass = [
    'spades-bid-panel',
    floating ? 'spades-bid-panel--float' : '',
  ].filter(Boolean).join(' ');

  const needsBiddingChoice = doubleNilEnabled
    && viewerBid == null
    && viewerBiddingChoice == null;

  if (needsBiddingChoice && (phase === 'bidding_choice' || phase === 'bidding')) {
    return (
      <div className={panelClass} role="dialog" aria-label="Choose bid type">
        <p className="spades-bid-prompt">Your turn to bid ({SEAT_LABELS[viewerSeat]})</p>
        <div className="spades-bid-actions">
          <button type="button" className="spades-bid-btn spades-bid-btn--nil" onClick={() => onBiddingChoice('double_nil')}>
            Blind nil
          </button>
          <button type="button" className="spades-bid-btn spades-bid-btn--primary" onClick={() => onBiddingChoice('bid')}>
            Bid
          </button>
        </div>
      </div>
    );
  }

  if (phase === 'bidding') {
    return (
      <div className={panelClass} role="dialog" aria-label="Place your bid">
        <p className="spades-bid-prompt">Your bid ({SEAT_LABELS[viewerSeat]})</p>
        <div className="spades-bid-grid">
          {Array.from({ length: 14 }, (_, n) => (
            <button
              key={n}
              type="button"
              className="spades-bid-btn"
              onClick={() => onBid(n)}
            >
              {n === 0 ? 'nil' : n}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return null;
}

export default SpadesBidPanel;